// extracted by mini-css-extract-plugin
export default {"wrapper":"SetPasswordForm_wrapper__LEYUF","form":"SetPasswordForm_form__i++DN"};